export default function CediSign() {
    return (
        <span>₵</span>
    )
}